import { router, usePage } from "@inertiajs/react"
import { useEffect } from "react"
import { toast } from "sonner"

import type { Flash, FlashMessage } from "@/types"

function toastAction(msg: FlashMessage) {
  if (typeof msg === "string") return undefined
  if (!msg.action) return undefined

  const { label, url, method = "get", data } = msg.action
  return {
    label,
    onClick: () => {
      router.visit(url, {
        method,
        data,
        preserveScroll: true,
      })
    },
  }
}

function textOf(msg: FlashMessage): string {
  return typeof msg === "string" ? msg : msg.text
}

export const useFlash = () => {
  const { flash } = usePage<{ flash: Flash }>().props

  useEffect(() => {
    // Content-derived ids so the same flash processed twice (page store
    // update + the entrypoint's http.onResponse patch) renders one toast.
    if (flash.alert) {
      toast.error(textOf(flash.alert), {
        id: `flash-alert-${textOf(flash.alert)}`,
        action: toastAction(flash.alert),
      })
    }
    if (flash.notice) {
      toast(textOf(flash.notice), {
        id: `flash-notice-${textOf(flash.notice)}`,
        action: toastAction(flash.notice),
      })
    }
  }, [flash])
}
